import { render, staticRenderFns } from "./DocumentosDigitales.vue?vue&type=template&id=69b9e67b&scoped=true&"
import script from "./DocumentosDigitales.vue?vue&type=script&lang=js&"
export * from "./DocumentosDigitales.vue?vue&type=script&lang=js&"
import style0 from "./DocumentosDigitales.vue?vue&type=style&index=0&id=69b9e67b&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b9e67b",
  null
  
)

export default component.exports